<script setup>
  import { watch } from "vue";
  import { storeToRefs } from "pinia";
  import ThreePanePage from "@templates/ThreePanePage.vue";
  import AudienceList from "@/components/MCampaign/Audiences/AudienceList.vue";
  import AudienceEdit from "@/components/MCampaign/Audiences/AudienceEdit/AudienceEdit.vue";
  import AudienceInfo from "@/components/MCampaign/Audiences/AudienceInfo.vue";
  import { useMAudiencesStore } from "@stores/mAudiences";
  import { useMCampaignStore } from "@stores/mCampaign";
  import { useUnsavedChangesGuard } from "@/utils/composables/useUnsavedChangesGuard";
  import { useMCampaignUnsavedChanges } from "@/utils/composables/useMCampaignUnsavedChanges";

  const mCampaignStore = useMCampaignStore();
  const audiencesStore = useMAudiencesStore();
  const { currentMCampaign } = storeToRefs(mCampaignStore);

  useUnsavedChangesGuard(useMCampaignUnsavedChanges().hasUnsavedChanges);

  watch(currentMCampaign, () => {
    if (currentMCampaign.value?.m_audiences?.length) {
      audiencesStore.selectAudience(0);
    }
  }, { immediate: true });
</script>

<template>
  <ThreePanePage data-cy="master-campaign-audiences-page">
    <template #left>
      <AudienceList />
    </template>
    <template #center>
      <AudienceEdit />
    </template>
    <template #right>
      <AudienceInfo />
    </template>
  </ThreePanePage>
</template>
